import { render, staticRenderFns } from "./PageLinksPreview.vue?vue&type=template&id=52080a3f"
import script from "./PageLinksPreview.vue?vue&type=script&lang=js"
export * from "./PageLinksPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports